(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(59622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




function Custom404() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                    variant: "h3",
                    component: "h1",
                    displayBlock: true,
                    textAlign: "center",
                    children: "Error 404"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                    variant: "subtitle2",
                    component: "p",
                    displayBlock: true,
                    textAlign: "center",
                    children: "Seite nicht gefunden"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/?from=404",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                            variant: "primary",
                            size: "md",
                            outlined: true,
                            rounded: true,
                            component: "a",
                            children: "Home"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Custom404);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);